export const EBON_ACTIVATION_TYPE_ONLINE = 'ONLINE';
export const EBON_ACTIVATION_TYPE_OFFLINE = 'OFFLINE';
export const EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE = 'ONLINE_AND_OFFLINE';

export const EBON_TYPE_DOWNLOAD_CODE = 'DOWNLOAD_CODE';
export const EBON_TYPE_LINK_CODE = 'LINK_CODE';

// valeur libre : montants candidats quand l'API ne remonte aucune valeur faciale (mêmes que Plebicard V2)
export const FREE_FACIAL_DEFAULT_VALUES = [10, 20, 30, 50, 100, 150, 200, 300, 400, 500];
export const FREE_FACIAL_DEFAULT_PROPOSALS_COUNT = 4;
export const FREE_FACIAL_PROPOSAL_QUANTITY = 20;
export const FREE_FACIAL_PROPOSAL_EXPIRATION_DATE = 32503680000000;



// WEBPACK FOOTER //
// ./src/constants/ebon.js